import React, { useState } from 'react';
import { Button, Fab, Tooltip } from '@mui/material';
import { BugReport as BugReportIcon } from '@mui/icons-material';
import BugReportDialog from './BugReportDialog';

const BugReportButton = ({ variant = 'button', size = 'medium', color = 'primary' }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClick = () => {
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  if (variant === 'fab') {
    return (
      <>
        <Tooltip title="Report Bug or Issue">
          <Fab
            color={color}
            size={size}
            onClick={handleClick}
            sx={{
              position: 'fixed',
              bottom: 16,
              right: 16,
              zIndex: 1000
            }}
          >
            <BugReportIcon />
          </Fab>
        </Tooltip>
        <BugReportDialog open={dialogOpen} onClose={handleClose} />
      </>
    );
  }

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<BugReportIcon />}
        onClick={handleClick}
        size={size}
        color={color}
      >
        Report Issue
      </Button>
      <BugReportDialog open={dialogOpen} onClose={handleClose} />
    </>
  );
};

export default BugReportButton;